
export function GetUser() {
    let user = null;
    if (localStorage.getItem('user')) {
        user = JSON.parse(localStorage.getItem('user'));
    }
    return user;
};

export function SetUser(value) {
    // console.log('auth setUser(): ', value)
    localStorage.setItem('user', JSON.stringify(value));
    // console.log("localStorage.getItem('user'): ", getUser())
};



// WEBPACK FOOTER //
// ./src/token.js